import axios from "axios";
import {
  UNIVERSITY_IMAGE_AC_IMAGE_TYPE_FAILED,
  UNIVERSITY_IMAGE_AC_IMAGE_TYPE_REQ,
  UNIVERSITY_IMAGE_AC_IMAGE_TYPE_RESET,
  UNIVERSITY_IMAGE_AC_IMAGE_TYPE_SUCCESS,
  UPLOAD_UNIVERSITY_IMAGE_FAILED,
  UPLOAD_UNIVERSITY_IMAGE_REQ,
  UPLOAD_UNIVERSITY_IMAGE_RESET,
  UPLOAD_UNIVERSITY_IMAGE_SUCCESS,
} from "../Constants/universityImageUploadConstant";
import axiosConfig from "../Core/axiosConfig";

export const UNIVERSITY_IMAGE_DETAILS_AC_UNIVERSITY =
  (university_id) => async (dispatch, getState) => {
    try {
      dispatch({ type: UNIVERSITY_IMAGE_AC_IMAGE_TYPE_REQ });
      let { data } = await axiosConfig.get(
        `/uploaduniversityimages/${university_id}`
      );

      if (data.Result === undefined) {
        dispatch({
          type: UNIVERSITY_IMAGE_AC_IMAGE_TYPE_FAILED,
          payload: data,
        });
      } else {
        dispatch({
          type: UNIVERSITY_IMAGE_AC_IMAGE_TYPE_SUCCESS,
          payload: data.Result,
        });
      }
    } catch (ex) {
      dispatch({
        type: UNIVERSITY_IMAGE_AC_IMAGE_TYPE_FAILED,
        payload: `Error-${ex.message}`,
      });
    }
  };

export const UNIVERSITY_IMAGE_DETAILS_AC_UNIVERSITY_RESET =
  () => (dispatch) => {
    dispatch({ type: UNIVERSITY_IMAGE_AC_IMAGE_TYPE_RESET });
  };

export const UNIVERSITY_IMAGE_UPLOAD =
  (upload_data, ImageType) => async (dispatch, getState) => {
    try {
      dispatch({ type: UPLOAD_UNIVERSITY_IMAGE_REQ });
      let { data } = await axios.post(
        `${process.env.REACT_APP_API}/uploaduniversityimages/${ImageType}`,
        upload_data,
        {
          headers: {
            "Content-type": "multipart/form-data",
          },
        }
      );

      if (data.Result === undefined) {
        dispatch({
          type: UPLOAD_UNIVERSITY_IMAGE_FAILED,
          payload: data,
        });
      } else {
        dispatch({
          type: UPLOAD_UNIVERSITY_IMAGE_SUCCESS,
          payload: data.Result,
        });
      }
    } catch (ex) {
      dispatch({
        type: UPLOAD_UNIVERSITY_IMAGE_FAILED,
        payload: `Error-${ex.message}`,
      });
    }
  };

export const UNIVERSITY_IMAGE_UPLOAD_RESET = () => (dispatch) => {
  dispatch({ type: UPLOAD_UNIVERSITY_IMAGE_RESET });
};
